import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Pagination, Spinner, Toast, Typography } from '@chilecompra/react-kit/components'
import { PUBLIC_URL, REACT_APP_BASE_URL } from '../../config/settings/environment'
import { PATH_PARAM } from '../../config/settings/regexes'
import routes from '../../config/settings/routes'
import { useRecaptcha } from '../../modules/hooks/recaptcha'
import { onGetGoogleRecaptchaTokenThunk } from '../Recaptcha/Recaptcha.actions'
import { onSearchBuyerPageThunk } from './SearchBuyer.actions'
import { Card, Column, ExternalLink, NotFoundImg, Paragraph, Root, Row, Strong } from './SearchBuyer.styles'

/**
 * The search result buyer section container.
 */
const SearchResultBuyer = () => {
  const dispatch = useDispatch()
  const { buyersView, page, totalPages, searching, success, totalRecordsCount, error } = useSelector(
    state => state.searchBuyer
  )
  const { error: recaptchaError } = useSelector(state => state.recaptcha)
  const { executeRecaptcha } = useRecaptcha('buyer_search_engine')

  const handleChange = (_, value) => {
    dispatch(
      onGetGoogleRecaptchaTokenThunk({
        executeRecaptcha,
        onSuccessCallback: () =>
          dispatch(
            onSearchBuyerPageThunk({
              page: value
            })
          )
      })
    )
  }

  return (
    <Root>
      {searching && (
        <Column align="center" margin="2rem 0 0">
          <Spinner />
        </Column>
      )}
      {!searching && success && (
        <Column>
          {/* No results found */}
          {totalRecordsCount === 0 && (
            <Card color="blank" padding="75.5px 0 74.5px" textAlign="center">
              <NotFoundImg alt="Imagen no encontrada" src={`${PUBLIC_URL}/assets/images/nofound.svg`} />
              <Typography variant="h4" fontWeight="bold" margin="8px 0">
                No se encontraron resultados para tu búsqueda
              </Typography>
              <Typography variant="body1" color="black3" fontSize="14px" lineHeight="18px">
                El comprador que buscas no se encuentra inscrito en
                <br />
                Mercado Público. Intenta con otra palabra clave u
                <br />
                otro criterio de búsqueda.
              </Typography>
            </Card>
          )}
          {/* Total results found */}
          {totalRecordsCount === 1 && (
            <Typography variant="body1" fontWeight="bold" fontSize="16px">
              Se ha encontrado 1 resultado para tu búsqueda.
            </Typography>
          )}
          {totalRecordsCount > 1 && (
            <Typography variant="body1" fontWeight="bold" fontSize="16px">
              Se han encontrado {totalRecordsCount} resultados para tu búsqueda.
            </Typography>
          )}
        </Column>
      )}
      {!searching && success && totalRecordsCount > 0 && (
        <Column>
          {buyersView.map((item, index) => (
            <Card enableBorder color="blank" key={`paper-${index}`} margin="0 0 0.4rem 0" padding="0.5rem">
              <Row alignItems="center" direction="row" justifyContent="space-around">
                <Column padding="0" width="20%" lg={3} md={3} sm={3} xs={4}>
                  <Paragraph item className="dni">
                    {item.dni}
                  </Paragraph>
                </Column>
                <Column padding="0" width="60%" lg={7} md={6} sm={6} xs={5}>
                  <Paragraph item className="orgLegalName" margin="1em 0">
                    {item.orgLegalName}
                  </Paragraph>
                </Column>
                <Column padding="0" width="20%" lg={2} md={3} sm={3} xs={3}>
                  <ExternalLink
                    key={`link-${index}`}
                    href={`${REACT_APP_BASE_URL}${routes.buyerCard.replace(PATH_PARAM, item.dni)}`}
                  >
                    Ver detalle
                  </ExternalLink>
                </Column>
              </Row>
            </Card>
          ))}
        </Column>
      )}
      {!searching && success && totalPages > 1 && (
        <Column>
          <Pagination alignment="left" boundaryCount={2} count={totalPages} page={page} onChange={handleChange} />
        </Column>
      )}
      {!searching && success !== undefined && !success && error !== undefined && (
        <Column>
          <Toast border severity="error">
            {error?.title && (
              <>
                <Strong>{error?.title}</Strong>
                <br />
              </>
            )}
            {error.message}
          </Toast>
        </Column>
      )}
      {!searching && recaptchaError !== undefined && recaptchaError?.reason === 'GOOGLE_RECAPTCHA_ERROR' && (
        <Column>
          <Toast border severity="error">
            No hemos podido realizar la verificación automática del recaptcha. Por favor, vuelve a cargar la página e
            inténtalo nuevamente.
          </Toast>
        </Column>
      )}
      {!searching && recaptchaError !== undefined && recaptchaError?.reason === 'SOMETHING_WENT_WRONG_ERROR' && (
        <Column>
          <Toast border severity="error">
            Lo sentimos, estamos presentando problemas con nuestro servidor
          </Toast>
        </Column>
      )}
    </Root>
  )
}

export default SearchResultBuyer
